import { useTranslation } from '@hooks/useTranslation';
import type { OrderSource } from '../types';

interface OrderSourceOverviewSectionProps {
  orderSource: OrderSource;
}

function FieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <span className="font-inter whitespace-nowrap text-sm font-semibold text-grey">
      {children}
    </span>
  );
}

function FieldValue({ children }: { children: React.ReactNode }) {
  return <p className="mt-2 font-inter text-sm text-off-black">{children}</p>;
}

function formatFee(fee: number | null, fee_type: OrderSource['fee_type']): string {
  if (fee === null || fee === undefined || fee === 0) return '—';
  return fee_type === 'Percentage' ? `${fee}%` : `$${fee}`;
}

export function OrderSourceOverviewSection({
  orderSource,
}: OrderSourceOverviewSectionProps) {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="mb-4 font-kapra-expanded text-2xl font-black uppercase leading-tight text-off-black">
        {t('preview_drawer.body.title', 'Overview')}
      </h3>

      <div className="flex flex-col gap-6 rounded-input border border-dinnerplate-white bg-off-white p-6">
        <div>
          <FieldLabel>{t('preview_drawer.body.source', 'Source')}</FieldLabel>
          <p className="mt-2 font-inter text-sm font-semibold text-off-black">
            {orderSource.name}
          </p>
        </div>

        <div className="flex gap-12">
          <div className="min-w-0 flex-1">
            <FieldLabel>{t('preview_drawer.body.fee_type', 'Fee type')}</FieldLabel>
            <FieldValue>{orderSource.fee_type || '—'}</FieldValue>
          </div>
          <div className="min-w-0 flex-1">
            <FieldLabel>{t('preview_drawer.body.fee', 'Fee')}</FieldLabel>
            <FieldValue>{formatFee(orderSource.fee, orderSource.fee_type)}</FieldValue>
          </div>
        </div>

        <div>
          <FieldLabel>{t('preview_drawer.body.description', 'Description')}</FieldLabel>
          <p className="mt-2 whitespace-pre-wrap font-inter text-sm text-off-black">
            {orderSource.description || '—'}
          </p>
        </div>
      </div>
    </div>
  );
}
